import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { PaginatedTableComponent } from './paginated-table.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';

@NgModule({
  declarations: [PaginatedTableComponent, FilterPanelComponent],
  imports: [
    CommonModule,
    TableModule,
    CheckboxModule,
    FormsModule,
    DialogModule,
    SelectModule,
    ButtonModule,
    AutoCompleteModule,
    InputTextModule,
    MenuModule
  ],
  exports: [
    PaginatedTableComponent
  ]
})

export class PaginatedTableModule {}